import { useTranslation } from 'helpers/hooks/useTranslation'
import React, { FC } from 'react'
import { SlugifiedAttributesFilterItemWithValues } from 'services/providers/bapi/entities/filters/normalize'
import { getStyleGroupFilterTitle } from 'sharedComponents/ProductFilter/util/getStyleGroupFilterTitle'
import { useAttributesFilterProps } from 'sharedComponents/ProductStream/filters/useAttributesFilterProps'
import styled from 'styled-components'
import RadioButton from 'uiComponents/atoms/Buttons/RadioButton'
import UnfoldingFilterBox from 'uiComponents/organisms/Filters/UnfoldingFilterBox'
import {
  useTrackOnCloseFilter,
  useTrackOnOpenFilter,
} from '../../../../helpers/tracking/hooks/trackFilter'

const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const StyleFilter: FC<{
  filter: SlugifiedAttributesFilterItemWithValues
}> = ({ filter }) => {
  const { t } = useTranslation()
  const { options, selectedValues, toggleSelection, onReset } =
    useAttributesFilterProps(filter, { allowOnlyOneSelected: true })
  const onCloseFilterTracking = useTrackOnCloseFilter()
  const onOpenFilterTracking = useTrackOnOpenFilter()
  const trackOnClose = () => {
    onCloseFilterTracking(filter.slug, 'quick_filters')
  }
  const trackOnOpen = () => {
    onOpenFilterTracking(filter.slug, 'quick_filters')
  }
  const getFilterContent = () => {
    return (
      <ListWrapper data-testid="FilterValues">
        {options.map(filterValue => (
          <RadioButton
            identifier={'styleGroupFilter'}
            label={getStyleGroupFilterTitle(t, filterValue)}
            key={filterValue.id}
            id={filterValue.id}
            onClick={toggleSelection}
            selected={selectedValues[0] === filterValue.id}
          />
        ))}
      </ListWrapper>
    )
  }

  return (
    <UnfoldingFilterBox
      label={t('Style')}
      key={filter.slug}
      dataTestId={`Style_Filter`}
      activeFiltersCount={selectedValues.length}
      onReset={onReset}
      styledContentStyles={{ padding: '24px' }}
      onClose={trackOnClose}
      onOpen={trackOnOpen}
    >
      {getFilterContent()}
    </UnfoldingFilterBox>
  )
}

export default StyleFilter
